import React from 'react';
import { NotebookPen } from 'lucide-react';
import { SUBSTACK } from '../../data/content';
import { LineRevealOnView, Reveal } from './Reveal';

export const Substack = () => (
  <section id="substack" className="bg-teal text-cream border-t border-cream/10 scroll-mt-20 overflow-hidden">
    <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-10 md:py-14">
      <div className="grid grid-cols-12 gap-y-8 items-center">
        <div className="col-span-12 md:col-span-3">
          <Reveal>
            <span className="text-xs tracking-[0.3em] uppercase text-cream/50 font-semibold">
              {SUBSTACK.overline}
            </span>
          </Reveal>
        </div>

        <div className="col-span-12 md:col-span-9 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-8">
          <LineRevealOnView
            lines={[SUBSTACK.title]}
            lineClassName="font-serif uppercase text-cream text-3xl sm:text-4xl lg:text-5xl leading-[1.04] tracking-[-0.01em]"
          />
          <Reveal delay={0.1}>
            <a
              data-testid="substack-link"
              href={SUBSTACK.link}
              target="_blank"
              rel="noreferrer"
              className="group shrink-0 inline-flex items-center gap-5 border border-cream/30 pl-7 pr-3 py-3 hover:border-cream transition-colors duration-500"
            >
              <span className="text-xs tracking-[0.22em] uppercase font-medium">
                {SUBSTACK.cta}
              </span>
              <span className="grid place-items-center w-11 h-11 rounded-full bg-cream text-teal transition-transform duration-500 group-hover:scale-105">
                <NotebookPen size={16} strokeWidth={1.6} />
              </span>
            </a>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
